/* Koriderm+ · controles del cajón del carrito (cantidad, eliminar, complementos y protección de envío) · v1.0 */
import { CartLinesUpdateEvent } from '@shopify/events';

const SECTION = 'cart-drawer-section';
let busy = false;

/** Lanza el evento estándar desde dentro del cajón: Horizon vuelve a renderizar la sección y actualiza la burbuja del header. */
function update(source, request, action, lines) {
  if (busy) return;
  busy = true;
  const drawer = source.closest('.kd-cart');
  drawer?.classList.add('is-busy');
  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'cart', lines, promise: deferred.promise }));

  fetch(request.url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...request.body, sections: SECTION, sections_url: window.location.pathname }),
  })
    .then((r) => r.json().then((j) => { if (!r.ok || j.errors) throw new Error(j.description || j.errors || j.message || 'Error'); return j; }))
    .then((res) => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, itemCount: cart.item_count, source: 'kd-cart', sections: res.sections, didError: false },
      });
    }))
    .catch((e) => { deferred.reject(e); alert(e.message); })
    .finally(() => { busy = false; drawer?.classList.remove('is-busy'); });
}

document.addEventListener('click', (e) => {
  const qty = e.target.closest('[data-kd-cart-qty]');
  if (qty) {
    const key = qty.dataset.lineKey;
    const n = parseInt(qty.parentElement.querySelector('.kd-cart__qty-n').textContent, 10) + parseInt(qty.dataset.kdCartQty, 10);
    update(qty, { url: '/cart/change.js', body: { id: key, quantity: Math.max(0, n) } }, n > 0 ? 'update' : 'remove', [{ id: key, quantity: Math.max(0, n) }]);
    return;
  }
  const rm = e.target.closest('[data-kd-cart-remove]');
  if (rm) {
    const key = rm.dataset.lineKey;
    update(rm, { url: '/cart/change.js', body: { id: key, quantity: 0 } }, 'remove', [{ id: key, quantity: 0 }]);
  }
});

document.addEventListener('change', (e) => {
  const t = e.target;
  if (!(t instanceof HTMLInputElement) || !t.hasAttribute('data-kd-cart-toggle')) return;
  const variant = t.dataset.variantId;
  const key = t.dataset.lineKey;
  if (t.checked) {
    update(t, { url: '/cart/add.js', body: { items: [{ id: +variant, quantity: 1 }] } }, 'add', [{ merchandiseId: String(variant), quantity: 1 }]);
  } else if (key) {
    update(t, { url: '/cart/change.js', body: { id: key, quantity: 0 } }, 'remove', [{ id: key, quantity: 0 }]);
  }
});
